<div class="modal-content" *ngIf="czyZaladowanoDane">
  <div class="modal-body">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="activeModal.dismiss()"
    ></button>
    <div class="ft__01 text-center py-2" *ngIf="idFiltra">Edytuj filtr</div>
    <div class="ft__01 text-center py-2" *ngIf="!idFiltra">Dodaj filtr</div>
    <div class="text-center mb-2"></div>
    <form action="">
      <div
        class="input_container pb-3"
        [ngClass]="czyBladWalidacyjny('nazwa') ? 'error' : ''"
      >
        <input
          type="text"
          placeholder="Nazwa"
          name="nazwa"
          [(ngModel)]="model.nazwa"
        />
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('nazwa')"
        >
          {{ pobierzBladWalidacyjny("nazwa") }}
        </div>
      </div>

      <div
        class="input_container mb-3"
        [ngClass]="czyBladWalidacyjny('polaSpisuId') ? 'error' : ''"
      >
        <ng-select
          placeholder="Pola spisu"
          [searchable]="true"
          [clearable]="false"
          [multiple]="true"
          [items]="polaSpisu"
          [(ngModel)]="model.polaSpisuId"
          bindLabel="nazwa"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          notFoundText="Brak pól"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
        >
        </ng-select>

        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('polaSpisuId')"
        >
          {{ pobierzBladWalidacyjny("polaSpisuId") }}
        </div>
      </div>

      <div
        class="input_container mb-3"
        [ngClass]="czyBladWalidacyjny('pokaz') ? 'error' : ''"
      >
        <select [(ngModel)]="model.pokaz" name="pokaz">
          <option [ngValue]="undefined" [disabled]="true">Pokaż</option>
          <option [ngValue]="0">Wszystko</option>
          <option [ngValue]="1">Niedobory</option>
          <option [ngValue]="2">Nadwyżki</option>
        </select>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('pokaz')"
        >
          {{ pobierzBladWalidacyjny("pokaz") }}
        </div>
      </div>

      <div class="container--main d-none d-md-block">
        <div class="ft__04 pt-4 text-center">Kolumny</div>
      </div>

      <div class="container pt-4 pb-md-5 mb-3">
        <div class="chb por mb-3" *ngFor="let kolumna of kolumnyDodatkowychPol">
          <input
            id="cb_{{ kolumna.id }}"
            type="checkbox"
            name="{{ kolumna.id }}"
            [(ngModel)]="kolumna.czyWybrano"
          />
          <label class="fs__chb" for="cb_{{ kolumna.id }}">{{
            kolumna.nazwa
          }}</label>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('kolumny')"
        >
          {{ pobierzBladWalidacyjny("kolumny") }}
        </div>
      </div>

      <div class="input_container pb-3 mt-3">
        <button class="btn__primary" (click)="zapisz()">Zapisz</button>
      </div>
      <div class="input_container pb-3">
        <button class="btn__link" (click)="activeModal.dismiss()">
          Anuluj
        </button>
        <div class="input_container pb-3 mt-3" *ngIf="idFiltra">
          <button class="btn__link btn__link--red" (click)="usun()">
            Usuń
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
